import React, { lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import ScrollToTop from './components/ScrollToTop';
import RouteMeta from './seo/RouteMeta';
import Footer from './components/footer/Footer';
import About from './pages/about/About';
import NotFound from './components/notfound/NotFound';
import ProjectDetails from './pages/about/project/ProjectDetails';
import AllServices from './pages/services/AllServices';
import Contact from './pages/about/contact/Contact';
import { VisitTracker } from './analytics/trackVisit';

import Hero from './components/home/Hero';
import AboutMe from './components/home/AboutMe';
import ProjectsShowcase from './components/home/ProjectsShowcase';
import Services from './components/home/Services';
import Pricing from './components/home/Pricing';
import ClientStories from './components/home/ClientStories';
import Faq from './components/home/Faq';
import Expertise from './components/home/Expertise';

// Admin and the blog (and the Firebase SDK they need) are only downloaded when opened.
const Admin = lazy(() => import('./pages/admin/Admin'));
const Blog = lazy(() => import('./pages/blog/Blog'));
const BlogPost = lazy(() => import('./pages/blog/BlogPost'));

// Keeps the footer below the fold while a lazy page loads.
const PageFallback = () => <div className="min-h-screen" />;

const Home = () => (
  <>
    <Hero />
    <AboutMe />
    <ProjectsShowcase />
    <Services />
    <Pricing />
    <ClientStories />
    <Faq />
    <Expertise />
  </>
);

const App = () => {
  // The admin panel is a standalone tool, so it skips the public site's navbar and footer.
  const isAdmin = useLocation().pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTop />
      <RouteMeta />
      <VisitTracker />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<AllServices />} />
        <Route path="/project/:id" element={<ProjectDetails />} />
        <Route
          path="/blog"
          element={
            <Suspense fallback={<PageFallback />}>
              <Blog />
            </Suspense>
          }
        />
        <Route
          path="/blog/:slug"
          element={
            <Suspense fallback={<PageFallback />}>
              <BlogPost />
            </Suspense>
          }
        />
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={null}>
              <Admin />
            </Suspense>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
};

export default App;
